import {
  PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_BEGIN,
  PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_SUCCESS,
  PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_FAILURE,
  PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_DISMISS_ERROR,
} from './constants'
import _ from 'lodash/fp'
import { BFFAgent } from '../../../common/BFFAgent'
import { validateCapMaxFinanciacion } from './BFFUtils'

const alertTypeFinancialLine = "financialLine"

export function getLineasFinancieras({ marcaId, modeloID, versionID, car_lot_id, nuevo, año, typeOfLine = 'TASA', tipoVenta }) {
  return async (dispatch) => {
    dispatch({
      type: PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_BEGIN,
    })

    const body = {
      marcaId,
      modeloID,
      versionID,
      car_lot_id,
      tipoMMV: nuevo ? '0Km' : 'Usados',
      yearMMV: nuevo ? undefined : año,
      typeOfLine: typeOfLine,
      catalog_id: versionID,
      tipoVenta: nuevo ? tipoVenta : undefined
    }

    try {
      const res = await BFFAgent.Presupuestador.getCreditsByMMV(body)
      if (_.isArray(res)) {
        dispatch({
          type: PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_SUCCESS,
          data: {
            lineas: res
          },
        })
      } else {
        dispatch({
          type: PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_SUCCESS,
          data: {
            lineas: [],
            message: res.message
          },
        })
      }
    }
    catch (err) {
      //Use rejectHandler as the second argument so that render errors won't be caught.
      
      dispatch({
        type: PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_FAILURE,
        data: { error: err },
      })
    }
  }
}

export function dismissGetLineasFinancierasError() {
  return {
    type: PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getLineasFinancierasPending: true,
        getLineasFinancierasError: null,
        lineasFinancieras: [],
        sinLineasMessage: null,
      }

    case PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_SUCCESS: {
      // The request is success

      // mutación de respuesta de backend
      // agregar objeto slider para el componente de ui rc-slider
      const lineasFinancieras = action.data.lineas.map((linea) => {
        const __linea = { ...linea }
        __linea.cuotasSlider = {}
        linea.lines.forEach(cuota => __linea.cuotasSlider[cuota.quantity] = `${cuota.quantity}`)
        return __linea
      })

      // comprobar si existe una linea seleccionada en el estado
      const lineaSeleccionada = lineasFinancieras.find(({ id }) => id === state.selectedLineaFinanciera)

      // conservar cuotas, monto y linea financiera si es que existen previamente

      //ordeno las lineas por TASA
      // const linesFinanceSort = lineasFinancieras.map(item=>{
      //   item.minTNA = Math.min(
      //     ...item.lines.map(({ tna }) => tna))
      //   return item
      // })
      // linesFinanceSort.sort((a,b)=> a.minTNA - b.minTNA)
      // README: ESTAS LINEAS SE COMENTAN POR SI HACE FALTA HACER UN
      // ROLLBACK, EN CASO DE NO SER NECESARIO SERÁN ELIMINADAS EN UN
      // PRÓXIMO PR
      
      //verifico que si cambia el monto maximo y es menor al monto agregado tiro el error
      let errorAmount = state.errorAmount

      if(state.alerts?.some(alert => alert.type === alertTypeFinancialLine)) {

        const { maxCap, exceedFinanceLimit } = validateCapMaxFinanciacion(
            lineasFinancieras,
            state.credit_line_id,
            state.credit_line_fees,
            state.nuevo?.bonification,
            state?.nuevo?.reference_price,
            state?.nuevo?.net_sale_price,
            state.special_discount,
            state?.nuevo?.nuevo
        )
        //cuando la línea puede exceder el límite no se valida que el monto supere al maximo a financiar
        errorAmount = exceedFinanceLimit ? false : state.credit_line_amount > maxCap
        
      }

      return {
        ...state,
        getLineasFinancierasPending: false,
        getLineasFinancierasError: null,
        lineasFinancieras: lineasFinancieras,
        sinLineasMessage: action.data.message,
        selectedLineaFinanciera: lineaSeleccionada ? state.selectedLineaFinanciera : undefined,
        cuotasAfinanciar: lineaSeleccionada ? state.cuotasAfinanciar : undefined,
        montoAfinanciar: lineaSeleccionada ? state.montoAfinanciar : undefined,
        errorAmount
      }}

    case PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_FAILURE: {
      // agregar objeto slider para el componente de ui rc-slider
      const lineasFinancieras2 = []
      if(action.data.lineas){
        action.data.lineas.forEach((linea) => {
          const __linea = { ...linea }
          __linea.cuotasSlider = {}
          linea.lines.forEach(cuota => __linea.cuotasSlider[cuota.quantity] = `${cuota.quantity}`)
          lineasFinancieras2.push(__linea)
        })
      }
      
      // comprobar si existe una linea seleccionada en el estado
      const lineaSeleccionada2 = lineasFinancieras2.find(({ id }) => id === state.selectedLineaFinanciera)
      // The request is failed
      return {
        ...state,
        getLineasFinancierasPending: false,
        getLineasFinancierasError: action.data.error,
        lineasFinancieras: [],
        selectedLineaFinanciera: undefined,
        cuotasAfinanciar: lineaSeleccionada2 ? state.cuotasAfinanciar : undefined,
        montoAfinanciar: lineaSeleccionada2 ? state.montoAfinanciar : undefined,
        sinLineasMessage: null,
      }}

    case PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_DISMISS_ERROR: {
      // agregar objeto slider para el componente de ui rc-slider
      const lineasFinancieras3 = []
      if(action.data.lineas){
        action.data.lineas.forEach((linea) => {
          const __linea = { ...linea }
          __linea.cuotasSlider = {}
          linea.lines.forEach(cuota => __linea.cuotasSlider[cuota.quantity] = `${cuota.quantity}`)
          lineasFinancieras3.push(__linea)
        })
      }
      // comprobar si existe una linea seleccionada en el estado
      const lineaSeleccionada3 = lineasFinancieras3.find(({ id }) => id === state.selectedLineaFinanciera)
      // Dismiss the request failure error
      return {
        ...state,
        getLineasFinancierasError: null,
        sinLineasMessage: null,
        cuotasAfinanciar: lineaSeleccionada3 ? state.cuotasAfinanciar : undefined,
        montoAfinanciar: lineaSeleccionada3 ? state.montoAfinanciar : undefined,
      }}

    default:
      return state
  }
}
